import DeleteIcon from '@mui/icons-material/Delete';
import InfoIcon from '@mui/icons-material/Info';
import { ListItemIcon, Tooltip, IconButton } from '@mui/material';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { BatchInsurerType, ClientType } from '../../types';
import { HHStack } from '@hinge-health/react-component-library';

export interface ClientInsurerBatchCardProps {
  id: number;
  client: ClientType;
  insurer: BatchInsurerType;
  showDivider?: boolean;
  showButton?: boolean;
  showToolTip?: boolean;
  primaryTypographyProps?: Record<string, string>;
  onRemove?: (id: number) => void;
  toolTipInfo?: string;
}

export const BATCH_CLIENT_INSURER_REMOVE_TEST_ID =
  'batch-client-insurer-remove-test-id';

export const BATCH_CLIENT_INSURER_CARD_DIVIDER_TEST_ID =
  'batch-client-insurer-divider-test-id';

export const FAILED_CONTRACT_ERROR_TOOLTIP_TEST_ID =
  'failed-contract-error-tooltip-test-id';
export const ClientInsurerBatchCard = ({
  id,
  client,
  insurer,
  showDivider = true,
  showButton = true,
  showToolTip = false,
  primaryTypographyProps = {},
  onRemove,
  toolTipInfo,
}: ClientInsurerBatchCardProps): JSX.Element => {
  const removeClientInsurer = (): void => {
    if (onRemove) {
      onRemove(id);
    }
  };

  return (
    <>
      <HHStack flexDirection={'row'} alignItems="center">
        <ListItem alignItems="flex-start">
          <ListItemText
            primary={client?.name}
            primaryTypographyProps={primaryTypographyProps}
            secondary={insurer?.name}
            secondaryTypographyProps={{ color: 'gray' }}
          />

          {showToolTip && toolTipInfo && (
            <ListItemIcon>
              <Tooltip title={toolTipInfo}>
                <InfoIcon
                  color="error"
                  data-testid={FAILED_CONTRACT_ERROR_TOOLTIP_TEST_ID}
                ></InfoIcon>
              </Tooltip>
            </ListItemIcon>
          )}
        </ListItem>
        {showButton ? (
          <IconButton
            size="small"
            color="primary"
            data-testid={BATCH_CLIENT_INSURER_REMOVE_TEST_ID}
            onClick={removeClientInsurer}
            aria-label="remove client insurer"
            sx={{
              padding: '4px',
              marginTop: '0',
              borderRadius: '50%',
              width: '28px',
              height: '28px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        ) : null}
      </HHStack>
      {showDivider ? (
        <Divider
          variant="middle"
          component="li"
          data-testid={BATCH_CLIENT_INSURER_CARD_DIVIDER_TEST_ID}
        />
      ) : null}
    </>
  );
};
